import React, {useContext} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {WindowPopup} from "../components/WindowPopup"
import config from "../config.json"
import {
    getAuthHeader, getItems,
    getLocalStorageItem,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {useHttp} from "../hooks/http.hook"
import {LoaderClass} from "../elements/LoaderClass"
import {LinksClass} from "../components/LinksClass";

export const LinkRenamePage = () => {
    setLocalStorageItem('page', 'LinkRenamePage')

    const lang = objectLang().language
    const navigate = useNavigate()
    const l = lang.lang

    const host =
        window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()

    const { id } = useParams()
    const name = new URLSearchParams(window.location.search).get('name')
    const thumbnail = new URLSearchParams(window.location.search).get('thumb')
    const from = new URLSearchParams(window.location.search).get('from') || 'us-link.cloud'
    let domain_url = new URLSearchParams(window.location.search).get('domain_url') || ''
    const parent = new URLSearchParams(window.location.search).get('parent') || `${auth.rootFolder}`

    const thumb = domain_url ? `${thumbnail}&domain_url=${domain_url}` : `${thumbnail}`

    const data = {
        noteId: id,
        oldName: name || '',
        typeData: 'link-rename',
        thumb,
        link: {from: from}
    }

    const onRename = async (name) => {
        if (!name) return
        try {
            const data = await request(
                `${host}/api/link/rename/${id}`,
                'POST',
                {
                    id,
                    name
                },
                {
                    Authorization: getAuthHeader(auth),
                    'Content-Type': 'application/json'
                })
            if (data.status !== 200) {
                setErrorWindow(
                    lang.modal.errors.title,
                    data.code,
                    lang.messages[`code_${data.code}`],
                    'off',
                    '',
                    lang.modal.errors.btnCancel,
                    'replaceToBack',
                )
                return navigate(`/${l}/modal`, {replace: true})
            }

            removeCookieOfFolderId(parent)
            window.location.replace(`/${l}/folder/open/${parent}`)

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass />
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            {data && (
                <WindowPopup data={data} lang={lang} title={lang.body.linkRenamePage.title} onRename={onRename} />
            )}
        </>
    )
}